var _path, _path2, _path3, _path4, _linearGradient, _path5, _linearGradient2, _path6, _linearGradient3, _path7, _linearGradient4, _path8, _path9, _path10, _path11;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDownloadOnThePlayStore(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 5436 1604",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M5234 1604H201c-111 0-201-90-201-200V201C0 90 90 0 201 0h5033c111 0 202 90 202 201v1203c0 110-91 200-202 200z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#a6a6a6",
    fillRule: "evenodd",
    d: "M5234 32c93 0 170 76 170 169v1203c0 92-76 168-170 168H201c-93 0-169-76-169-168V201c0-93 76-169 169-169h5033zm0-32H201C90 0 0 90 0 201v1203c0 110 90 200 201 200h5033c111 0 202-90 202-200V201c0-111-91-201-202-201z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M2864 531a128 128 0 0 1-128-130 127 127 0 0 1 128-130 128 128 0 0 1 128 130 128 128 0 0 1-128 130zm-1080 0c-36 0-67-13-92-38-25-24-38-55-38-92s13-68 38-92a126 126 0 0 1 143-27c16 7 29 16 38 28l3 3-27 26-3-3a77 77 0 0 0-63-27 89 89 0 0 0-89 92 89 89 0 0 0 89 92c26 0 48-8 65-25 10-10 16-24 18-42h-87v-37h124l1 3 2 19c0 34-11 62-31 83-24 24-54 37-91 37zm1436-6h-39l-117-187 1 33v154h-38V277h43l2 2 110 176-1-33V277h39v248zm-644 0h-39V314h-67v-37h173v37h-67v211zm-138 0h-39V277h39v248zm-217 0h-39V314h-67v-37h173v37h-67v211zm-131 0h-148V277h148v37h-110v68h99v37h-98v68h109v38zm711-58c17 17 38 26 63 26s45-8 62-26c17-17 26-39 26-66s-9-49-26-66a86 86 0 0 0-62-26c-25 0-46 8-63 26-17 17-26 39-26 66s9 49 26 66z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M2732 872c-94 0-171 72-171 171 0 98 77 171 171 171 95 0 171-73 171-171 0-99-76-171-171-171zm0 274c-52 0-96-43-96-103 0-62 45-104 96-104 52 0 96 42 96 104 0 61-44 103-96 103zm-373-274c-95 0-171 72-171 171 0 98 77 171 171 171s171-73 171-171c0-99-77-171-171-171zm0 274c-52 0-96-43-96-103 0-62 44-104 96-104s96 42 96 104c0 61-44 103-96 103zm-444-221v72h173c-5 40-19 70-39 91-26 25-65 53-134 53-106 0-190-86-190-193a190 190 0 0 1 321-141l51-51a269 269 0 0 0-450 192c0 146 122 264 268 264 79 0 139-25 185-74 48-48 63-115 63-169 0-17-1-32-4-45h-244v1zm1817 56c-15-39-58-109-147-109-87 0-160 69-160 171 0 95 72 170 169 170 78 0 123-48 142-76l-58-38a97 97 0 0 1-84 47c-38 0-65-18-83-52l228-94-7-19zm-233 57a94 94 0 0 1 89-100c30 0 55 15 63 36l-152 64zm-185 165h74V702h-74v501zm-123-293h-3c-17-20-49-38-90-38-85 0-164 75-164 171s78 170 164 170c40 0 73-18 90-39h3v25c0 65-35 100-91 100-46 0-75-33-86-61l-65 27c18 45 68 101 151 101 87 0 162-52 162-178V882h-71v28zm-86 236c-52 0-95-43-95-103s43-104 95-104c51 0 90 44 90 104 1 60-39 103-90 103zm977-444h-179v501h75v-190h104c83 0 165-60 165-155s-81-156-165-156zm2 241h-106V771h106c57 0 88 47 88 86 0 40-32 86-88 86zm463-71c-55 0-111 24-134 76l67 28c14-28 40-37 68-37 39 0 78 23 79 64v6c-14-8-43-20-78-20-72 0-145 40-145 113 0 67 59 111 125 111 50 0 78-23 95-49h3v38h72v-192c0-89-67-138-152-138zm-9 274c-25 0-59-12-59-43 0-39 42-53 79-53 33 0 49 7 68 17-5 45-43 79-88 79zm424-264-86 218h-3l-89-218h-80l133 304-76 169h78l206-473h-83zm-674 321h75V702h-75v501z",
    clipRule: "evenodd"
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 1682.1,
    x2: 1624.3,
    y1: 1339.5,
    y2: 1309.6,
    gradientTransform: "matrix(11.64 0 0 -22.55 -18706 30554)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00a0ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00a1ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#00beff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#00d2ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#00dfff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00e3ff"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    fillRule: "evenodd",
    d: "M418 302a81 81 0 0 0-18 57v886c0 25 7 45 19 57l3 2 497-497v-11L422 299l-4 3z",
    clipRule: "evenodd"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 1712.7,
    x2: 1606.6,
    y1: 1274.8,
    y2: 1274.8,
    gradientTransform: "matrix(9.145 0 0 -7.7 -14306 10618)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#ffbd00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "orange"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff9c00"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    fillRule: "evenodd",
    d: "M1084 974 918 808v-12l166-165 4 2 196 111c56 32 56 84 0 116l-196 111-4 3z",
    clipRule: "evenodd"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 1707.4,
    x2: 1646.7,
    y1: 1290,
    y2: 1211.2,
    gradientTransform: "matrix(15.02 0 0 -11.5775 -24650 15830)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff3a44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c31162"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    fillRule: "evenodd",
    d: "M1088 971 918 802l-500 500c19 20 49 22 84 3l586-334",
    clipRule: "evenodd"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 1660.6,
    x2: 1687.8,
    y1: 1365.7,
    y2: 1330.5,
    gradientTransform: "matrix(15.02 0 0 -11.5715 -24650 15810)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#32a071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#2da771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#15cf74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#06e775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00f076"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    fillRule: "evenodd",
    d: "M1088 633 502 300c-35-20-65-17-84 3l500 499 170-169z",
    clipRule: "evenodd"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "m1084 968-582 330c-32 19-61 18-80 1l-3 3 3 3c19 16 48 18 80-1l586-333-4-3z",
    clipRule: "evenodd",
    opacity: 0.2
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "m1284 854-201 114 4 3 196-111c28-16 42-37 42-58-2 19-16 37-41 52z",
    clipRule: "evenodd",
    opacity: 0.1
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "m502 306 782 444c25 14 39 33 41 52 1-21-13-42-41-58L502 300c-56-32-102-5-102 59v5c0-64 46-90 102-58z",
    clipRule: "evenodd",
    opacity: 0.3
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadOnThePlayStore);
export default __webpack_public_path__ + "static/media/download-on-the-play-store.ef8785323fa8b126b6cca66094d07d1e.svg";
export { ForwardRef as ReactComponent };